import { PropertyValueSet } from "@genesys/property";
import {
  SettingsCollection,
  getDefaultCaseOverrides,
  getCoordinateFromClimateDataProperties,
  getDefaultLoadNameAbbrevation
} from "../../../tools";
import * as SharedState from "../../../../shared-state";

import * as GraphQLTypes from "../../../../graphql-types";
import * as ClimateSettingsEditor from "../../../components/climate-settings-editor";

import * as OperationTime from "@genesys/client-core/lib/operation-time-dialog";

import { LoadDef } from "../../../main-content/load-types";
import { Defaults } from "./types";
import uuid from "uuid";

export function createInitialInputsFromDefaults(
  defaults: Defaults,
  binLocations: ReadonlyArray<GraphQLTypes.BinLocationType>,
  climateDataFomMlSettings: PropertyValueSet.PropertyValueSet,
  allLoads: LoadDef[],
  sharedState: SharedState.State
): SettingsCollection {
  const coordinate = getCoordinateFromClimateDataProperties(
    defaults.defaultClimateSettings
  );
  const binData = ClimateSettingsEditor.defaultBinDataLocationProperties(
    binLocations,
    coordinate
  );

  return {
    climateData: PropertyValueSet.isEmpty(climateDataFomMlSettings)
      ? defaults.defaultClimateSettings
      : climateDataFomMlSettings,
    moistureLoadSettings: defaults.defaultMoistureLoadSettings,
    mainSettingsOverrides: defaults.defaultMainSettingsOverrides,
    binData,
    loadSettings: createDefaultLoadSettings(
      defaults.loadCreationProperties,
      allLoads,
      sharedState
    ),
    systemOperationTime: OperationTime.presets.allDay
  };
}

function createDefaultLoadSettings(
  settings: PropertyValueSet.PropertyValueSet,
  allLoads: LoadDef[],
  sharedState: SharedState.State
): ReadonlyArray<SettingsCollection["loadSettings"][0]> {
  const activeLoads = getActiveLoadsFromSettings(allLoads, settings);

  return activeLoads.map((x, index) => {
    const matchingLoad = allLoads.find(l => l.sourceName === x)!;
    const operationTime = matchingLoad.operationalTime?.getDefaultOperationTime
      ? matchingLoad.operationalTime.getDefaultOperationTime(settings)
      : OperationTime.presets.factoryHours;

    const loadNameAbbreviation = getDefaultLoadNameAbbrevation(
      sharedState,
      matchingLoad.title
    );
    return {
      id: uuid.v4(),
      sortNo: index, // TODO: x.sortNo,
      name: `${loadNameAbbreviation}-1`,
      loadType: x,
      settings: settings,
      operationTime,
      caseOverrides: getDefaultCaseOverrides(settings)
    };
  });
}

function getActiveLoadsFromSettings(
  loadsDefMap: ReadonlyArray<LoadDef>,
  moistureLoadSettings: PropertyValueSet.PropertyValueSet
) {
  return loadsDefMap
    .filter(x => {
      const hasHeat = x.additionalInfo.isHeatAdded(moistureLoadSettings);
      const hasMoist = x.additionalInfo.isMoistureAdded(moistureLoadSettings);

      return hasHeat || hasMoist;
    })
    .map(x => x.sourceName);
}
